import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { DatepickerMode } from '@richardlt/ng2-semantic-ui/modules/datepicker/components/datepicker';
import { AdvanceSearchModal } from '../../modals/advanced-search-modal/advanced-search-modal.component';
import { AppFilter } from '../../models/filter';
import { StoreFilterService } from 'src/modules/shared/services';

@Component({
  selector: 'app-advanced-search-filter',
  templateUrl: './advanced-search-filter.component.html',
  styleUrls: ['./advanced-search-filter.component.scss'],
})
export class AdvancedSearchFilterComponent {
  @Input() displayRows: number = 5;
  @Input() pending: boolean;
  @Input() field: any;
  @Input() headers: any;
  @Input() headerFilters: any;
  @Input() datePaidSearch: boolean = false;
  @Input() hasAdvancedSearch: boolean = false;
  @Input() hasFilters: boolean = false;
  @Input() hasSort: boolean = true;
  @Input() hasDisplayRows: boolean = true;
  @Input() searchFilters: any;
  @Input() showExportBtn: boolean = false;
  @Input() showAddBtn: boolean = false;
  @Input() filter: AppFilter = new AppFilter();
  @Input() searchText: string = '';
  @Input() placeholder: string = 'Search';
  @Input() exportNew: boolean = false;

  @Output() onFilter: EventEmitter<any> = new EventEmitter();
  @Output() advancedSearch: EventEmitter<any> = new EventEmitter();
  @Output() cancelAd: EventEmitter<any> = new EventEmitter();
  @Output() datePaidAd: EventEmitter<any> = new EventEmitter();
  @Output() onSearch: EventEmitter<any> = new EventEmitter();
  @Output() onSort: EventEmitter<any> = new EventEmitter();
  @Output() onDisplayRows: EventEmitter<number> = new EventEmitter();
  @Output() onYearSelect: EventEmitter<any> = new EventEmitter();
  @Output() export: EventEmitter<any> = new EventEmitter();
  @Output() onExportSearch: EventEmitter<any> = new EventEmitter();
  @Output() add: EventEmitter<any> = new EventEmitter();

  selectedItems = [];

  public mode: DatepickerMode = 'year';
  public maxDate = new Date();
  showCancelBtn = false;
  @Input() selectedDate = new Date();
  currentYear: any = this.selectedDate.getFullYear();
  options = [
    { label: 'Ascending', value: 'asc' },
    { label: 'Descending', value: 'desc' },
  ];
  sord = 'desc';
  filters: any;
  searchTimeout: any;

  constructor(
    private modalService: SuiModalService,
    private storeFilterService: StoreFilterService
  ) {}

  searchTextChanged(ev: any) {
    this.searchText = ev.target.value;
    this.onSearch.emit(this.searchText);
  }

  yearChanged(event) {
    if (event) {
      this.currentYear = event.getFullYear();
      this.onYearSelect.emit(event.getFullYear());
    }
  }

  isFieldAsc(field: string) {
    if (this.filter.sord === 'asc' && this.filter.sidx === field) {
      this.filter.sord = 'asc';
      this.onFilter.emit(this.filter);
      return;
    }
  }

  isFieldDesc(field: string) {
    if (this.filter.sord === 'desc' && this.filter.sidx === field) {
      this.filter.sord = 'desc';
      this.onFilter.emit(this.filter);
      return;
    }
  }

  sortByColumn(field: string) {
    return {
      asc: this.isFieldAsc(field),
      desc: this.isFieldDesc(field),
    };
  }

  onDisplayRecords($event) {
    this.onDisplayRows.emit($event);
  }

  onSearchRecords($event) {
    clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(() => {
      this.onSearch.emit($event);
    }, 500);
  }

  onSortRecords(value) {
    this.onSort.emit(value);
  }

  cancelAdvanceSearch() {
    this.storeFilterService.setFilter(null);
    this.showCancelBtn = false;
    window.localStorage.removeItem('AdSearch');
    this.selectedItems = [];
    this.searchFilters['rules'] = [];
    this.searchFilters['groupOp'] = '';
    this.cancelAd.emit();
  }

  onAdvanceSearch() {
    this.modalService
      .open(
        new AdvanceSearchModal(
          'Advanced Search',
          this.headers,
          [],
          ModalSize.Normal
        )
      )
      .onApprove((payload) => {
        this.showCancelBtn = true;
        this.searchFilters['groupOp'] = payload['groupOp'];
        this.searchFilters['rules'] = payload['rules'];
        this.advancedSearch.emit(this.searchFilters);
      })
      .onDeny(() => {
        // Handle deny action if needed
      });
  }

  isChecked(choice, field) {
    if (
      this.selectedItems.filter(
        (i) => i['data'] == choice['optionId'] && i['field'] == field
      ).length > 0
    ) {
      return true;
    } else {
      return false;
    }
  }

  singleSelect(choice, event, field) {
    if (event.target.checked) {
      this.selectedItems.push({
        field: field,
        label: choice['optionName'],
        data: choice['optionId'],
      });
      this.searchFilters['rules'].push({
        field: field,
        op: 'eq',
        data: choice['optionId'],
      });
    } else {
      this.selectedItems.forEach((id) => {
        if (id['data'] == choice['optionId'] && id['field'] == field) {
          this.selectedItems.splice(this.selectedItems.indexOf(id), 1);
        }
      });
      this.searchFilters['rules'].forEach((id) => {
        if (id['data'] == choice['optionId'] && id['field'] == field) {
          this.searchFilters['rules'].splice(
            this.searchFilters['rules'].indexOf(id),
            1
          );
        }
      });
    }
    this.advancedSearch.emit(this.searchFilters);
  }

  removeSelectedItem(item) {
    this.selectedItems.forEach((id) => {
      if (id['data'] == item['data'] && id['field'] == item['field']) {
        this.selectedItems.splice(this.selectedItems.indexOf(id), 1);
      }
    });
    this.searchFilters['rules'].forEach((id) => {
      if (id['data'] == item['data'] && id['field'] == item['field']) {
        this.searchFilters['rules'].splice(
          this.searchFilters['rules'].indexOf(id),
          1
        );
      }
    });
    this.advancedSearch.emit(this.searchFilters);
  }
}
